import { apiClient } from '@shared/services/api';

export const prefix = '/apps/publisher';
export async function get(path, params) { return (await apiClient.get(prefix + path, { params })).data; }
export async function post(path, payload, options) { return (await apiClient.post(prefix + path, payload || {}, options)).data; }
export async function put(path, payload) { return (await apiClient.put(prefix + path, payload)).data; }
export async function patch(path, payload) { return (await apiClient.patch(prefix + path, payload)).data; }
export async function remove(path) { return (await apiClient.delete(prefix + path)).data; }
// The shared client defaults to JSON, which would turn a FormData body into an empty object.
export async function uploadForm(path, form) {
  return (await apiClient.post(prefix + path, form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
}
// Shared work jobs: cancel never-started work, or ask running work to stop.
export async function stopJob(jobId) { return (await apiClient.post('/jobs/' + jobId + '/stop')).data; }

export function message(error) {
  const response = error && error.response;
  const detail = response && response.data && response.data.detail;
  if (typeof detail === 'string') return detail;
  if (detail && detail.message) return detail.message;
  if (Array.isArray(detail)) {
    return detail.map(item => item.msg || ('Please check ' + String((item.loc || []).slice(-1)[0] || 'the form').replace(/_/g, ' ') + '.')).join(' ');
  }
  if (response && response.status === 402) return 'You do not have enough credits for this. Add credits or choose a plan.';
  return error && error.workPending ? 'Your request is still being confirmed. Try again with the same settings to resume it.'
    : 'We could not reach the server. Please try again.';
}

export function code(error) {
  const detail = error && error.response && error.response.data && error.response.data.detail;
  return detail && typeof detail === 'object' ? detail.code || '' : '';
}

// Private media is served to the signed-in owner only, so it is fetched with the
// session and shown through object URLs (cached per page load).
const cache = new Map();
export function mediaUrl(path) {
  if (!path) return Promise.resolve('');
  if (!cache.has(path)) {
    const request = apiClient.get(path, { responseType: 'blob' })
      .then(response => URL.createObjectURL(response.data))
      .catch(error => { cache.delete(path); throw error; });
    cache.set(path, request);
  }
  return cache.get(path);
}

export async function download(path, filename) {
  const url = await mediaUrl(path);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}
